import { render, staticRenderFns } from "./ListUserPage.vue?vue&type=template&id=60315161"
import script from "./ListUserPage.vue?vue&type=script&lang=js"
export * from "./ListUserPage.vue?vue&type=script&lang=js"
import style0 from "./ListUserPage.vue?vue&type=style&index=0&id=60315161&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports